module.exports = __webpack_public_path__ + "media/test.47b75ba4.mp4";